module.exports = __webpack_public_path__ + "5fd82db8d7131c7202eb73ee12af1aa2.svg";